import React, { useEffect } from "react";
import { Carousel } from "react-bootstrap";
import UserActionVideo from "./UserActionVideo";

// UserActionCarousel
const UserActionCarousel = ({
  userAction,
  handleSelect,
  index,
  direction,
  handleImageLoaded,
}) => {
  const steps =
    userAction && Array.isArray(userAction.action_steps)
      ? userAction.action_steps
      : [];

  useEffect(() => {
    if (steps.length > 0) {
      const sorted = [...steps].sort((a, b) => a.order - b.order);
      if (sorted[index] && sorted[index].video) {
        handleImageLoaded();
      }
    } else {
      if (handleImageLoaded) {
        handleImageLoaded();
      }
    }
  }, [userAction, index]);

  return (
    <div className="useraction-carousel-wrapper">
      <Carousel
        activeIndex={steps.length > 0 ? index : 0}
        direction={direction}
        onSelect={handleSelect}
        controls={false}
      >
        {steps.length > 0 ? (
          [...steps]
            .sort((a, b) => a.order - b.order)
            .map((action, actionIndex) => (
              <Carousel.Item key={action.order || actionIndex}>
                {action.video ? (
                  <UserActionVideo
                    index={index}
                    action={action}
                    actionIndex={actionIndex}
                  />
                ) : action.image ? (
                  <img
                    width={900}
                    height={500}
                    alt="900x500"
                    src={action.image}
                    onLoad={handleImageLoaded}
                  />
                ) : (
                  <img
                    src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='900' height='500' viewBox='0 0 900 500'><rect width='900' height='500' fill='%23f3f4f6'/><path d='M420 180 h60 v100 h-60 z' fill='none' stroke='%23d1d5db' stroke-width='4'/><circle cx='450' cy='230' r='15' fill='%23e5e7eb' stroke='%23d1d5db' stroke-width='4'/><text x='50%' y='65%' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='20' fill='%239ca3af'>MiniBrew Setup</text></svg>"
                    alt="placeholder"
                    onLoad={handleImageLoaded}
                  />
                )}
              </Carousel.Item>
            ))
        ) : (
          <Carousel.Item>
            <img
              src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='900' height='500' viewBox='0 0 900 500'><rect width='900' height='500' fill='%23f3f4f6'/><path d='M420 180 h60 v100 h-60 z' fill='none' stroke='%23d1d5db' stroke-width='4'/><circle cx='450' cy='230' r='15' fill='%23e5e7eb' stroke='%23d1d5db' stroke-width='4'/><text x='50%' y='65%' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='20' fill='%239ca3af'>MiniBrew</text></svg>"
              alt="placeholder"
              onLoad={handleImageLoaded}
            />
          </Carousel.Item>
        )}
      </Carousel>
    </div>
  );
};

export default UserActionCarousel;
